import { TFunction } from 'i18next'
import { DataItem } from 'scrivito'

import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import { DataItemNewTabLink } from '@/Components/shared/DataItemNewTabLink'
import { DownloadAnchor } from '@/Components/shared/DownloadAnchor'

export interface FolderMenuHandlers {
  onRename: (e: React.MouseEvent) => void
  onUnlink: (e: React.MouseEvent) => void
}

export const buildFolderMenuItems = (
  t: TFunction,
  { onRename, onUnlink }: FolderMenuHandlers,
): MenuItemProps[] => [
  {
    icon: 'edit',
    label: t('common.rename'),
    onClick: onRename,
  },
  {
    icon: 'unlink',
    label: t('common.unlink'),
    onClick: onUnlink,
  },
]

export interface FileMenuHandlers {
  document: DataItem
  downloadUrl: string
  downloadName: string
  onEdit: (e: React.MouseEvent) => void
  onUnlink: (e: React.MouseEvent) => void
}

export const buildDocumentMenuItems = (
  t: TFunction,
  { document, downloadUrl, downloadName, onEdit, onUnlink }: FileMenuHandlers,
): MenuItemProps[] => {
  const items: MenuItemProps[] = [
    {
      icon: 'link-external',
      label: t('common.openInNewTab'),
      as: DataItemNewTabLink,
      dataItem: document,
    },
  ]

  if (downloadUrl) {
    items.push({
      icon: 'download-circle',
      label: t('common.download'),
      as: DownloadAnchor,
      url: downloadUrl,
      name: downloadName,
    })
  }

  items.push(
    {
      icon: 'edit',
      label: t('common.edit'),
      onClick: onEdit,
    },
    {
      icon: 'unlink',
      label: t('common.unlink'),
      onClick: onUnlink,
    },
  )

  return items
}
